<template>
    <div class="section">
        <Login />
        <!-- <pre>{{user}}</pre> -->
        <!-- <Login  v-if="!(user && !user.isAnonymous)" /> -->
        <!-- <pre>{{ user }}</pre> -->
     
        <!-- <div v-if="user && !user.isAnonymous" class="container find-trips"> -->
            <!-- <pre >{{user}}</pre> -->
        <div v-if="user && !user.isAnonymous" class="container find-trips">
            <h1 class="title is-2">APPROVE bike trip journals.</h1>
            <div style="font-size:22px">{{Object.keys(unapprovedPages).length + ' posts submitted'}}</div><br>
            <div class="new-pages">
                <div 
                    v-for="page in this.unapprovedPages"
                    v-bind:key = page.id
                    
                    >
                    <PageResult 
                        :page = "page"
                        :ref="'visibleCard'"
                        :class="'visible'"
                        :approveMode = "true"
                        :adminRequired = "true"

                    />
                    <!-- <AdminApproveNewPage 
                        v-bind:page = "page"/> -->
                    <!-- <pre>{{page}}</pre> -->
                </div>
            </div>
        </div>
     
    </div>  
</template>

<script>
// import {allcountries} from "../data.js";
import CustomTagInput from '@/components/CustomTagInput';
// import AdminApproveNewPage from '@/components/AdminApproveNewPage';
import Login from '@/components/Login';
import PageResult from '@/components/PageResult';

export default {
    name: 'AdminApproveNew',
    components: {Login, PageResult},
   
    data () {
        return {
         
            unapprovedPages:[],
            showingFiltered:false,
            
        }
    
    },
    computed: {
       countryArray: function() {
            if (this.$countrymap) {
                var tosave = [];
                for (const prop in this.$countrymap) {
                    var elem = {code:prop, name:this.$countrymap[prop]};
                    tosave.push(elem);
                }
                return tosave;
            } else {
                return [];
            }
       },
       user: function() {
            return this.$getParent('App').user; 
        }
    },
    methods: {
     
        loadNewPages() {
            var that = this;
            this.$db.collection("pages_unapproved").where("submitted", "==", true)
                .get()
                .then(function(querySnapshot) {
                    that.unapprovedPages = [];
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        // console.log(that[outname]);
                        // console.log(doc.data());
                        // that.unapprovedPages.push({id: doc.id, data: doc.data()});
                        const idObj = {id: doc.id};
                        that.unapprovedPages.push({...idObj, ...doc.data()});
                    });
                    console.log("Loading unapproved pages");
                    console.log(that.unapprovedPages);
                })
                .catch(function(error) {
                    console.log("Error getting documents: ", error);
                });
        }
        
    },
    mounted() {
        this.loadNewPages();

      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   
   
    .field {
        margin-top:20px;
    }
    .margin-bottom {
        margin-bottom:10px;
    }
  
</style>


<!-- 
TODO
- disallow dup urls - if already exists, offer option to edit instead (change merge to false)
- strip after ?
- extract human readable key from url
- validate url
- tags for solo etc, surface, language
- let people add new tags for route
- states for US


 -->



// WEBPACK FOOTER //
// src/components/AdminApproveNew.vue